import React from 'react';
import { colorPalette } from '../../colorPalette';
import { RakutenIcon } from '@next-common/material-ui-icons';
import Box from "@mui/material/Box";
export const Label = (props) => {
    const { children, backgroundColor, textColor, icon, iconSize, letterSpacing, fontSize, borderRadius, margin, padding, border, textTransform, fontWeight, lineHeight, iconStyle, } = props;
    const labelStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: fontWeight || 600,
        lineHeight: lineHeight || '15px',
        backgroundColor: backgroundColor ? colorPalette[backgroundColor] : colorPalette.white,
        color: textColor ? colorPalette[textColor] : colorPalette.white,
        letterSpacing: letterSpacing || '1px',
        fontSize: fontSize || '12px',
        borderRadius: borderRadius || '4px',
        margin: margin || 0,
        padding: padding || '4px 8px',
        border: border || 'none',
        textTransform: textTransform || 'uppercase',
    };
    return (React.createElement(Box, { sx: labelStyle, "data-qa": "label" },
        React.createElement(RakutenIcon, { icon: icon, style: Object.assign({ fontSize: iconSize || 14, marginRight: 4 }, iconStyle) }),
        children));
};
